/* tslint:disable */
/* eslint-disable */
/* @relayHash 5b1768ccf7c3aa83c2711fc883d12e42 */

import { ConcreteRequest } from "relay-runtime";
export type SearchSectionsQueryVariables = {
    text?: string | null;
    includeCompliance: boolean;
};
export type SearchSectionsQueryResponse = {
    readonly delegates: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly TTC_ID: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly profileImageUrl: string | null;
            readonly documents: {
                readonly edges: ReadonlyArray<{
                    readonly uuid: string;
                    readonly name: string;
                    readonly url: string | null;
                    readonly expiryDate: string | null;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly ttcDelegates: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly TTC_ID: string;
            readonly firstName: string;
            readonly lastName: string;
            readonly profileImageUrl: string | null;
            readonly documents: {
                readonly edges: ReadonlyArray<{
                    readonly uuid: string;
                    readonly name: string;
                    readonly url: string | null;
                    readonly expiryDate: string | null;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly backgroundChecks?: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly approvalDate: string | null;
            readonly expiresAt: string | null;
            readonly isRenewal: boolean;
            readonly isVerification: boolean;
            readonly onlyDBS: boolean;
            readonly delegate: {
                readonly uuid: string;
                readonly firstName: string;
                readonly lastName: string;
            };
        }>;
    };
    readonly audits?: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly reportNumber: number;
            readonly createdAt: string;
            readonly pdfUrl: string | null;
            readonly auditTemplate: {
                readonly name: string;
                readonly auditType: string;
            };
        }>;
    };
    readonly machineReports?: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly title: string;
            readonly reportDate: string;
            readonly previewURL: string;
            readonly machine: {
                readonly name: string;
            };
        }>;
    } | null;
};
export type SearchSectionsQuery = {
    readonly response: SearchSectionsQueryResponse;
    readonly variables: SearchSectionsQueryVariables;
};



/*
query SearchSectionsQuery(
  $text: String
  $includeCompliance: Boolean!
) {
  delegates(filter: {name: $text}, page: {limit: 5}) {
    edges {
      uuid
      TTC_ID
      firstName
      lastName
      profileImageUrl
      documents(page: {limit: 3}) {
        edges {
          uuid
          name
          url
          expiryDate
        }
      }
    }
  }
  ttcDelegates: delegates(filter: {ttc_id: $text}, page: {limit: 5}) {
    edges {
      uuid
      TTC_ID
      firstName
      lastName
      profileImageUrl
      documents(page: {limit: 3}) {
        edges {
          uuid
          name
          url
          expiryDate
        }
      }
    }
  }
  backgroundChecks(filter: {searchText: $text}, page: {limit: 4}) @include(if: $includeCompliance) {
    edges {
      uuid
      approvalDate
      expiresAt
      isRenewal
      isVerification
      onlyDBS
      delegate {
        uuid
        firstName
        lastName
      }
    }
  }
  audits(filter: {searchText: $text}, page: {limit: 4}) @include(if: $includeCompliance) {
    edges {
      uuid
      reportNumber
      createdAt
      pdfUrl
      auditTemplate {
        name
        auditType
      }
    }
  }
  machineReports(filter: {searchText: $text, sent: true}, page: {limit: 4}) @include(if: $includeCompliance) {
    edges {
      uuid
      title
      reportDate
      previewURL
      machine {
        name
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "text",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "includeCompliance",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Literal",
        "name": "page",
        "value": {
            "limit": 5
        }
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "Delegate",
            "plural": true,
            "selections": [
                (v2 /*: any*/),
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "TTC_ID",
                    "args": null,
                    "storageKey": null
                },
                (v3 /*: any*/),
                (v4 /*: any*/),
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "profileImageUrl",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "documents",
                    "storageKey": "documents(page:{\"limit\":3})",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "page",
                            "value": {
                                "limit": 3
                            }
                        }
                    ],
                    "concreteType": "DocumentPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Document",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "expiryDate",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ], v7 = ({
        "kind": "Variable",
        "name": "searchText",
        "variableName": "text"
    } as any), v8 = ({
        "kind": "Literal",
        "name": "page",
        "value": {
            "limit": 4
        }
    } as any), v9 = [
        ({
            "kind": "ObjectValue",
            "name": "filter",
            "fields": [
                (v7 /*: any*/)
            ]
        } as any),
        (v8 /*: any*/)
    ], v10 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "delegates",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "filter",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "text"
                        }
                    ]
                },
                (v1 /*: any*/)
            ],
            "concreteType": "DelegatePage",
            "plural": false,
            "selections": (v6 /*: any*/)
        } as any),
        ({
            "kind": "LinkedField",
            "alias": "ttcDelegates",
            "name": "delegates",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "filter",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "ttc_id",
                            "variableName": "text"
                        }
                    ]
                },
                (v1 /*: any*/)
            ],
            "concreteType": "DelegatePage",
            "plural": false,
            "selections": (v6 /*: any*/)
        } as any),
        ({
            "kind": "Condition",
            "passingValue": true,
            "condition": "includeCompliance",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "backgroundChecks",
                    "storageKey": null,
                    "args": (v9 /*: any*/),
                    "concreteType": "BackgroundCheckPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BackgroundCheck",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "approvalDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "expiresAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isRenewal",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isVerification",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "onlyDBS",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "delegate",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Delegate",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "audits",
                    "storageKey": null,
                    "args": (v9 /*: any*/),
                    "concreteType": "AuditPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Audit",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "reportNumber",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "createdAt",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pdfUrl",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "auditTemplate",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AuditTemplate",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "auditType",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "machineReports",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "ObjectValue",
                            "name": "filter",
                            "fields": [
                                (v7 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "sent",
                                    "value": true
                                }
                            ]
                        },
                        (v8 /*: any*/)
                    ],
                    "concreteType": "MachineReportPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MachineReport",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "reportDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "previewURL",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "machine",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Machine",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SearchSectionsQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v10 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "SearchSectionsQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v10 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "SearchSectionsQuery",
            "id": null,
            "text": "query SearchSectionsQuery(\n  $text: String\n  $includeCompliance: Boolean!\n) {\n  delegates(filter: {name: $text}, page: {limit: 5}) {\n    edges {\n      uuid\n      TTC_ID\n      firstName\n      lastName\n      profileImageUrl\n      documents(page: {limit: 3}) {\n        edges {\n          uuid\n          name\n          url\n          expiryDate\n        }\n      }\n    }\n  }\n  ttcDelegates: delegates(filter: {ttc_id: $text}, page: {limit: 5}) {\n    edges {\n      uuid\n      TTC_ID\n      firstName\n      lastName\n      profileImageUrl\n      documents(page: {limit: 3}) {\n        edges {\n          uuid\n          name\n          url\n          expiryDate\n        }\n      }\n    }\n  }\n  backgroundChecks(filter: {searchText: $text}, page: {limit: 4}) @include(if: $includeCompliance) {\n    edges {\n      uuid\n      approvalDate\n      expiresAt\n      isRenewal\n      isVerification\n      onlyDBS\n      delegate {\n        uuid\n        firstName\n        lastName\n      }\n    }\n  }\n  audits(filter: {searchText: $text}, page: {limit: 4}) @include(if: $includeCompliance) {\n    edges {\n      uuid\n      reportNumber\n      createdAt\n      pdfUrl\n      auditTemplate {\n        name\n        auditType\n      }\n    }\n  }\n  machineReports(filter: {searchText: $text, sent: true}, page: {limit: 4}) @include(if: $includeCompliance) {\n    edges {\n      uuid\n      title\n      reportDate\n      previewURL\n      machine {\n        name\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '176451abc8423f3ec3b35dd372a45210';
export default node;
